import React from "react"
import Trans from './Trans'

class MissingData extends React.Component {
  render() {
    return (
      <div className='flex flex-col justify-center items-center'>
        <span className="w-full text-center font-semibold text-gray-700 text-2xl"><Trans>Keine Auktionen gefunden.</Trans></span>
      </div>
    )
  }
}

export default MissingData
